import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';
declare var bootstrap: any;

@Component({
  selector: 'job-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './job-details.component.html',
  styleUrls: ['./job-details.component.css']
})
export class JobDetailsComponent implements OnInit {
  @Input() data: any = {
    data: {
    title: 'Java Developer',
    Company: {
      name: 'Tech Solutions',
    },
    address:{
    location: 'New York, USA',
    },
    experienceRequired: '2+ years',
    status: 'New',
    salary: '$80,000 - $100,000',
    employmentType: 'Full-time',
    role: "junior developer",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "Angular",
      "React",
      "MySQL",
      "PostgreSQL",
      "MongoDB"
    ],
    opening: '6',
    applyText: 'Apply Now',
    viewRecruiterText: 'View Recruiter',
    qualifications: [],
    created: 'January 29, 2025'
  }
  };

  @Input() config: any = {
    wrapperClass: 'wrapper',
    containerClass: 'container mt-5',
    cardClass: 'card shadow-sm',
    cardHeaderClass: 'card-header text-center',
    headingClass: 'h4',
    cardBodyClass: 'card-body',
    buttonContainerClass: 'd-flex justify-content-center mt-3',
    applyButtonClass: 'btn btn-success mx-2',
    viewRecruiterButtonClass: 'btn btn-secondary mx-2',
    textBoldClass: 'fw-bold',
    applyText: 'Apply Now',
    viewJobText: 'View Job',
    viewRecruiterText: 'View Recruiter'
  };
openCommentModal: any;
toggleButtonClick: any;
redirectToJobDetails: any;
onShareClick: any;

  constructor(private view: ViewContainerRef) {}

  ngOnInit(): void {
    console.log("Job Data:", this.data);
    
    // Ensure `data` is an object
    if (typeof this.data === 'string') {
      try {
        this.data = JSON.parse(this.data);
      } catch (error) {
        console.error("Invalid JSON format for data:", error);
      }
    }

    // Ensure `config` is an object
    if (typeof this.config === 'string') {
      try {
        this.config = JSON.parse(this.config);
      } catch (error) {
        console.error("Invalid JSON format for config:", error);
      }
    }
  }

  openModal() {
    let modalElement = document.getElementById('jobDetailsModal');
    let modal = new bootstrap.Modal(modalElement);
    modal.show();
  }

  viewJob() {
   
  }

  applyJob() {
    alert('Your application has been submitted successfully!');
  }

  redirectToRecruiter() {
    if (!this.data?.userId) {
      console.error('User ID is missing');
      return;
    }

    const recruiterId = this.data?.WidgetDetails?.config?.recruiterProfiLinkToId || 'defaultId';

    const dataParams = {
      where: {
        id: this.data.userId
      }
    };

    let queryParams = {
      dataModel: 'citizen-users',
      dataParams: JSON.stringify(dataParams)
    };

    console.log(JSON.stringify(dataParams));

    const customEvent = new CustomEvent('redirect', {
      bubbles: true,
      cancelable: true,
      detail: {
        data: {
          isExternalRedirect: false,
          redirectUrl: `/w/${recruiterId}/recruiterprofile`,
          queryParams: JSON.stringify(queryParams)
        }
      }
    });

    this.view.element.nativeElement.dispatchEvent(customEvent);
  }
}
